var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2443 1.16667C9.39909 1.16664 9.54755 1.22814 9.65698 1.33762L11.7876 3.46915C12.0153 3.69693 12.0153 4.06614 11.7876 4.29392L5.75509 10.3291C5.64569 10.4385 5.49727 10.5 5.34252 10.5H3.20834C2.88617 10.5 2.625 10.2388 2.625 9.91667V7.79331C2.625 7.63872 2.68637 7.49045 2.79561 7.38108L8.83168 1.33777C8.94107 1.22825 9.0895 1.1667 9.2443 1.16667Z",
    fill: "#97BDC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04167 11.6667C1.7195 11.6667 1.45834 11.9278 1.45834 12.25C1.45834 12.5722 1.7195 12.8333 2.04167 12.8333H12.5417C12.8638 12.8333 13.125 12.5722 13.125 12.25C13.125 11.9278 12.8638 11.6667 12.5417 11.6667H2.04167Z",
    fill: "#97BDC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f1e8fa002b9c0148c0e18f47fd4a4547.svg";
export { ForwardRef as ReactComponent };